import { Component } from '@angular/core';

@Component({
  selector: 'app-processing-warning-notification',
  templateUrl: './processing-warning-notification.html',
  styleUrl: './processing-warning-notification.scss',
})
export class ProcessingWarningNotification {}
